import { Box } from '@pets-ui/Box/Box'
import { Chip } from '@pets-ui/Chip/Chip'
import { Sort } from '@pets-ui/Icons'
import * as stylex from '@stylexjs/stylex'

const styles = stylex.create({
  labelText: {
    gap: 2,
    alignItems: 'center',
    display: 'inline-flex',
  },
})

export interface CategoryProductsFilterProps {
  isFilteredByCoupon?: boolean
  handleFilterByCouponClick?: () => void
  disabled?: boolean
}

export const CategoryProductsFilter = ({ isFilteredByCoupon, handleFilterByCouponClick, disabled }: CategoryProductsFilterProps) => {
  return (
    <Box p={2}>
      <Chip
        isOutlined
        size="small"
        xStyles={{ labelText: styles.labelText }}
        selected={isFilteredByCoupon}
        color={isFilteredByCoupon ? 'red' : 'default'}
        onClick={handleFilterByCouponClick}
        disabled={disabled}
      >
        <Sort fontSize={18} />
        僅顯示活動品
      </Chip>
    </Box>
  )
}
